import { Form } from "@minervaproject/fds";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { resetPassword } from "../api";
import { ErrorMessage } from "../components/sso/error_message";
import { OrgWrapper } from "../components/sso/org_wrapper";
import { Paragraph } from "../components/sso/paragraph";
import { PasswordInput } from "../components/sso/password_input";
import { SubmitButton } from "../components/sso/submit_button";
import { Title } from "../components/sso/title";
import { getOrgOrGeneralUrl } from "../helpers";
import { LoginStore } from "../store/login";

const PasswordReset = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { orgIdentifier } = useParams();

  const { loading, error } = useSelector(LoginStore.sliceSelectors.select());

  const onFormSubmit = () => async ({ realpassword }) => {
    try {
      await resetPassword({
        password: realpassword,
        token: window.context?.resetToken,
      });
      const contextualMessage =
        "Thank you. Your new password has been successfully created. Please sign in with it now.";
      dispatch(LoginStore.actions.update({ contextualMessage }));
      history.push(getOrgOrGeneralUrl(orgIdentifier, "password"));
    } catch {
      dispatch(LoginStore.actions.setError("Sorry, something went wrong. Please try again."));
    }
  };

  const displayName = window.context?.displayName;
  const text = `Hi ${displayName}. Please submit your new password below. It must be at least eight characters long and contain one upper case letter and one number.`;

  return (
    <OrgWrapper>
      <Title text="Reset Password" />
      <Paragraph text={text} />
      <Form onSubmit={onFormSubmit}>
        <PasswordInput newPassword />
        <PasswordInput confirmPassword />
        <SubmitButton loading={loading} text="Reset Password" />
        {error ? <ErrorMessage msg={error} /> : null}
      </Form>
    </OrgWrapper>
  );
};

export { PasswordReset };
